import "./assets/base.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import api from "./services/api";

// Swallow the benign ResizeObserver loop warning so it doesn't trigger the
// webpack-dev-server error overlay. The browser fires it whenever an observer
// callback causes another resize that can't be delivered in the same frame;
// nothing is broken, but the overlay treats every uncaught error as fatal.
const RESIZE_OBSERVER_NOISE = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications.",
];
window.addEventListener("error", (event) => {
  if (event && RESIZE_OBSERVER_NOISE.includes(event.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

const app = createApp(App);

// Make api available globally
app.config.globalProperties.$api = api;

app.use(router);

app.mount("#app");
